import * as React from "react";
import "./section.css";
import { useTranslation } from 'react-i18next';
import { analyticsService } from "../../services/AnalyticsService";

export type SectionTextProps = {
  text: String,
  readMoreUrl: String,
  style?: any
}

export const SectionText = (props: SectionTextProps) => {
  const { t } = useTranslation('translation');

  function onLinkClicked() {
    if (process.env.REACT_APP_ENV === "prod") {
      analyticsService().trackPage("websiteAction", {
        where: window.location.href,
        clicked: "Read more",
        openedPage: props.readMoreUrl
      });
    }
  }

  return (
    <div className="sectionText-main body-large-regular" style={props.style}>
      <div dangerouslySetInnerHTML={{ __html: props.text }} />
      {props.readMoreUrl ?
        <a className="section-readmore-text"
          onClick={() => onLinkClicked()}
          href={props.readMoreUrl}
          target="_blank"
          rel="noopener noreferrer">{t("readMore")}
        </a>
        : null}
    </div>
  )
}